import { Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useFetchActiveProject from '../../hooks/useFetchActiveProject';
import { useSelector } from 'react-redux';
import { ProjectSelector } from '../../pages/project-management/project-list/data-access/+state/project-list.selectors';
import { ProjectListActions } from '../../pages/project-management/project-list/data-access/+state/project-list.actions';
import { Project } from '@app/shared/types/project.type';

interface ActionDropdownItemsProps {
  project?: Project | null;
  basePath?: string;
}

const ActionDropdownItems = (props?: ActionDropdownItemsProps) => {
  const { project: projectProp, basePath = '/project' } = props ?? {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useFetchActiveProject();
  const activeProject = useSelector(ProjectSelector.activeProject);
  const project = projectProp ?? activeProject;

  const handleUploadPending = (e: React.MouseEvent) => {
    if (project) {
      e.preventDefault();
      dispatch(ProjectListActions.setActiveProject({ activeProject: project }));
      navigate(`${basePath}/update-project`);
    }
  };

  return (
    <>
      <Dropdown.Item
        href={project ? `${basePath}/update-project` : '#'}
        onClick={project ? handleUploadPending : undefined}
        eventKey="1"
      >
        Upload Pending
      </Dropdown.Item>
      <Dropdown.Item eventKey="1">Analysis</Dropdown.Item>
      <Dropdown.Item eventKey="2">Report</Dropdown.Item>
      <Dropdown.Item eventKey="2">Dashboard</Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
